import { GetAllFulfillmentOrdersForAdminState } from './getAllFulfillmentOrdersForAdmin.types'

const initialState: GetAllFulfillmentOrdersForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
